import React from "react";
import { Paper, Box, Typography, Stack, Chip, Avatar } from "@mui/material";
import { CampaignOutlined, CalendarTodayOutlined } from "@mui/icons-material";
import {
  textPrimary,
  textSecondary,
  softShadow,
  accentColor,
  color1,
  myApi,
} from "../../../constants/consts";

// Flutter: 'dd/MM/yyyy HH:mm'
const formatDate = (input) => {
  if (!input) return "";
  try {
    const d = new Date(input);
    if (isNaN(d.getTime())) return input; // parse edilemediyse ham string
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
      d.getHours(),
    )}:${p(d.getMinutes())}`;
  } catch {
    return input;
  }
};

export default function NotificationCard({ notification }) {
  const {
    title = "-",
    description = "",
    created_at = "",
    img = "",
  } = notification || {};

  const imgUrl = img
    ? img.startsWith("http")
      ? img
      : `${myApi}/${img.replace(/^\/+/, "")}`
    : null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: softShadow,
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.06)",
        transition: "all 0.25s ease",
        "&:hover": {
          boxShadow: `0 10px 24px ${accentColor}33`,
          borderColor: `${accentColor}55`,
        },
      }}
    >
      {/* Üst satır: ikon + başlık + tarih */}
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <Avatar
          variant="rounded"
          sx={{
            width: 40,
            height: 40,
            backgroundColor: `${accentColor}1A`,
            color: accentColor,
            borderRadius: 2,
          }}
        >
          <CampaignOutlined sx={{ fontSize: 20 }} />
        </Avatar>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            fontWeight={800}
            color={textPrimary}
            sx={{ lineHeight: 1.35, mb: 0.5 }}
          >
            {title}
          </Typography>

          {created_at && (
            <Chip
              size="small"
              icon={<CalendarTodayOutlined fontSize="small" />}
              label={formatDate(created_at)}
              sx={{
                backgroundColor: "rgba(0,0,0,0.05)",
                color: textSecondary,
                fontWeight: 600,
                height: 24,
                "& .MuiChip-icon": { color: textSecondary, fontSize: 14 },
              }}
            />
          )}
        </Box>
      </Stack>

      {/* Açıklama */}
      {description && (
        <Typography
          variant="body2"
          color={textSecondary}
          sx={{
            mt: 2,
            lineHeight: 1.6,
            whiteSpace: "pre-wrap",
          }}
        >
          {description}
        </Typography>
      )}

      {/* Görsel (16:6 oranı, Flutter'daki gibi) */}
      {imgUrl && (
        <Box
          sx={{
            mt: 2,
            borderRadius: 2,
            overflow: "hidden",
            aspectRatio: "16 / 6",
            backgroundColor: color1,
          }}
        >
          <Box
            component="img"
            src={imgUrl}
            alt={title}
            onError={(e) => {
              e.currentTarget.style.display = "none";
              e.currentTarget.parentElement.innerHTML =
                '<div style="height:100%;display:flex;align-items:center;justify-content:center;color:#94a3b8;font-size:13px">Görsel yüklenemedi</div>';
            }}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      )}
    </Paper>
  );
}
